import { render, staticRenderFns } from "./send-during-hours-section.vue?vue&type=template&id=39a7132e&"
import script from "./send-during-hours-section.vue?vue&type=script&lang=js&"
export * from "./send-during-hours-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports